import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NotificationService } from '../../service/common/notification/notification.service';
import { WestnetzSidenavService } from '../../service/common/westnetz-sidenav/westnetz-sidenav.service';
import { take } from 'rxjs/operators';
import { DienstleistungsModuleBeschreibung } from '../../domain/model/dienstleistungsmodulebeschreibung.model';
import { DienstleistungsmoduleService } from '../../service/dienstleistungsmodule/dienstleistungsmodule.service';

@Component({
    selector: 'redispatch-settings-dienstleistungsmodule-detail',
    templateUrl: './settings-dienstleistungsmodule-detail.component.html',
    styleUrls: [
        './settings-dienstleistungsmodule-detail.component.scss',
    ],
    standalone: false,
})
export class SettingsDienstleistungsmoduleDetailComponent implements OnInit {
    public module: DienstleistungsModuleBeschreibung = new DienstleistungsModuleBeschreibung();

    public westnetzSidenavService = inject(WestnetzSidenavService);
    private dienstleistungsmoduleService = inject(DienstleistungsmoduleService);
    private activatedRoute = inject(ActivatedRoute);
    private notificationService = inject(NotificationService);
    private changeDetectorRef = inject(ChangeDetectorRef);

    ngOnInit() {
        const moduleId = this.activatedRoute.snapshot.queryParams['module'];
        this.dienstleistungsmoduleService.getDienstleistungsModuleBeschreibung(moduleId)
            .pipe(take(1))
            .subscribe((data: DienstleistungsModuleBeschreibung) => {
                this.module = data;
                this.changeDetectorRef.markForCheck();
            });
    }

    save() {
        this.dienstleistungsmoduleService.updateDienstleistungsModuleBeschreibung(this.module).subscribe(() => {
            this.westnetzSidenavService.closeRightnav();
            this.notificationService.success('Die Anpassungen wurden erfolgreich gespeichert');
        });
    }

}
